// extracted by mini-css-extract-plugin
export default {"disclaimers":"hJH5MY79C6uuY3OOYK0uOg==","stamp-duty-disclaimer":"bRQQXsLJB8eRInPZhC-9oQ==","draft-disclaimer":"HZh4iNjzOeDnQ86InK0w8A=="};